// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalHeader_header__WtLsw","title":"ModalHeader_title__xpuh4","button":"ModalHeader_button__eB_61"};